import { Container, Grid } from '@mui/material';
import React from 'react';
import Heading from '../components/heading';
import P1 from '../assets/partner1.png';
import P2 from '../assets/partner2.png';
import P3 from '../assets/partner3.png';
import P4 from '../assets/partner4.png';
import P5 from '../assets/partner5.png';
import P6 from '../assets/partner6.png';
import P7 from '../assets/partner7.png';
import { AllImage } from '../styling/style';
import styled from '@emotion/styled';

const CGrid = styled(Grid)`
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: auto;
    @media (max-width: 599px){
        padding: 5% 0%;
    }
`
const LogoImage = styled(AllImage)`
     @media (max-width: 599px){
       max-width: ${props => props.mws? props.mws : ''};
    }
`
const Partner = () => {
    return(
        <Container>
            <Grid container>
                <Heading
                    title = 'Partners'
                    p = '5% 0% 1%'
                />
                <CGrid container  data-aos="fade-up" data-aos-duration="1200"> 
                    <Grid xs={6} md={3} sm={4} py={2}>
                        <LogoImage mws='100px' maxw = '165px'  src={P1}/>
                    </Grid>
                    <Grid xs={6} md={3} sm={4} py={2}>
                        <LogoImage mws='100px' maxw = '200px' src={P2}/>
                    </Grid>
                    <Grid xs={6} md={3} sm={4} py={2}>
                        <LogoImage mws='140px' maxw = '200px' src={P3}/>
                    </Grid>
                    <Grid xs={6} md={3} sm={4} py={2}>
                        <LogoImage mws='140px' maxw = '200px' src={P4}/>
                    </Grid>
                    <Grid xs={6} md={3} sm={4} py={2}>
                        <LogoImage mws='100px' maxw = '200px' src={P5}/>
                    </Grid>
                    <Grid xs={6} md={3} sm={4} py={2}>
                        <LogoImage mws='100px' maxw = '200px' src={P6}/>
                    </Grid>
                    <Grid xs={6} md={3} sm={4} py={2}>
                        <LogoImage mws='120px' maxw = '200px' src={P7}/>
                    </Grid>
                </CGrid>
            </Grid>
        </Container>
    )
}
export default Partner;